import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import { DialogChildContentWrapper } from '@shared/components/core/dialog/CoreDialogStyles';
import { useCurrentOrgDeviceTypeEditor } from '@shared/hooks/useCurrentOrgDeviceTypeEditor';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import DeviceTypeNameEditor from './editors/DeviceTypeNameEditor';
import DeviceTypeSupportFeaturesEditor from './editors/DeviceTypeSupportFeaturesEditor';
import DeviceTypeToggleEditor from './editors/DeviceTypeTogglesEditor';

export interface ICreateDeviceTypeDialogProps {
    open: boolean;
    onClose: () => void;
    index?: number;
    onCreated?: (newDeviceTypeId: string, index: number) => void;
}

export default function CreateDeviceTypeDialog({ open, onClose, index, onCreated }: ICreateDeviceTypeDialogProps) {
    const { t } = useTranslation();
    const { editDeviceType, handleCreateAndClearEditor, handleInputChange, resetEditor } =
        useCurrentOrgDeviceTypeEditor(null);

    const handleSaveAndClose = async () => {
        const response = await handleCreateAndClearEditor();
        if (response.resultType === 'Ok' && response.data) {
            onCreated?.(response.data.id, index ?? -1);
            onClose();
        }
    };

    useEffect(() => {
        if (open) {
            resetEditor();
        }
    }, [open]);

    if (!editDeviceType) return null;
    return (
        <ContentDialog
            fullWidth
            open={open}
            onClose={onClose}
            onCancel={onClose}
            title={t('common:organization.projects.deviceType.action')}
            description={t('common:organization.projects.deviceType.description')}
            onConfirm={handleSaveAndClose}>
            <DialogChildContentWrapper>
                <DeviceTypeNameEditor
                    value={editDeviceType.name}
                    onUpdate={(field, value) => handleInputChange(field, value)}
                />
                <DeviceTypeSupportFeaturesEditor editDeviceType={editDeviceType} onUpdate={handleInputChange} />
                <DeviceTypeToggleEditor editDeviceType={editDeviceType} onUpdate={handleInputChange} />
            </DialogChildContentWrapper>
        </ContentDialog>
    );
}
